module.exports = __webpack_public_path__ + "static/media/web.d7544a6d.jpg";